import React from 'react';
import { ShieldCheck } from 'lucide-react';
export function ProductTitle() {
  return <div data-id="element-670" data-mp="3tfzhe1fccsul">
      {/* Desktop/tablet H1 (Desc1). On mobile the H1 is rendered above the gallery instead. */}
      <div className="hidden lg:block mb-4" data-id="element-671" data-mp="3fgznofcz1nrk">
        <h1 className="text-2xl md:text-3xl font-bold text-brand-charcoal leading-tight" data-id="element-672" data-mp="3fiatsltw37lu">
          20mm Corner Radius End Mill TuffCutt®XR Carbide 4 Flute Standard
          AlTiN Coated MA Ford
        </h1>
        <p className="mt-2 flex flex-wrap gap-x-4 gap-y-1 text-sm text-gray-500 font-mono" data-id="element-673" data-mp="c1ua9kk58jl3">
          <span data-id="element-674" data-mp="g0jikyqbraxv">DIA=20mm</span>
          <span data-id="element-675" data-mp="29y2tiw63h47">LOC=38mm</span>
          <span data-id="element-676" data-mp="28v9z5fab4ln">OAL=104mm</span>
          <span data-id="element-677" data-mp="29o9blbwyrtr">SHK=20.0mm</span>
          <span data-id="element-678" data-mp="7912soxaix5b">CR=3.0mm</span>
        </p>
      </div>

      <div className="flex flex-wrap items-center gap-3 text-sm text-gray-600" data-id="element-679" data-mp="77g9t3qmjm9k">
        <span className="font-semibold text-brand-charcoal" data-id="element-680" data-mp="uxkd19zwhk01">SKU:</span>
        <span className="bg-gray-50 border border-gray-200 px-2 py-0.5 rounded font-mono font-bold text-brand-charcoal" data-id="element-681" data-mp="zp25tarrse9x">
          17778707A
        </span>

        <span className="text-gray-300" data-id="element-682" data-mp="zqg09wwgx3qb">|</span>

        <span className="flex items-center gap-1 text-green-700 font-medium" data-id="element-683" data-mp="vp4jmgvknsu9">
          <ShieldCheck className="w-4 h-4" data-id="element-684" data-mp="19fzm9bfh9dpe" />
          All items proudly made in the USA!
        </span>
      </div>
    </div>;
}